<div class="breadcrumbs">
  @for (crumb of breadcrumbs; track crumb; let index = $index) {
    @if (crumb.titleArgs) {
      <a class="crumb" [attr.href]="crumb.url">
        {{ crumb.title | translate: crumb.titleArgs }}
      </a>
    } @else {
      @if (crumb.url.length){
        <a class="crumb" [attr.href]="crumb.url">{{ crumb.title | translate }}</a>
      } @else {
        <span class="crumb">{{ crumb.title | translate }}</span>
      }
    }
    <span class="slash" *ngIf="index !== breadcrumbs.length - 1">/</span>
  }
</div>
